module.exports = __webpack_public_path__ + "img/etc-etc-new-arrow-top.fa699a94.svg";